import React from 'react';
import PropTypes from 'prop-types';
import { merge } from 'lodash';
import { ApolloProvider } from '@apollo/client';
import { ApolloClient } from '@sm360/widget-commons-general';

import config from 'commons-garage/config/index.js';
import { ContentZonesService, LocaleService } from '@sm360/widget-commons-core-services';
import { PurchaseMethods, Vehicle, ModelYear, Quote } from '@sm360/widget-commons-vehicle';

import GarageView from 'commons-garage/components/Garage/GarageView.jsx';

import en from 'commons-garage/i18n/en.json';
import fr from 'commons-garage/i18n/fr.json';

class GarageProvider extends React.Component {
    constructor(props) {
        super(props);

        merge(en, Vehicle.Translation.en, PurchaseMethods.Translations.en, ModelYear.Translations.en);
        merge(fr, Vehicle.Translation.fr, PurchaseMethods.Translations.fr, ModelYear.Translations.fr);

        LocaleService.loadTranslations({ en, fr });

        ContentZonesService.setImageServerBaseUrl(config.source.image);
        ContentZonesService.addContentZones(props.contentZones);
    }

    render() {
        return (
            <ApolloProvider client={ApolloClient.getOrCreate()}>
                <GarageView {...this.props} />
            </ApolloProvider>
        );
    }
}

GarageProvider.defaultProps = {
    isNewEnabled: true,
    isUsedEnabled: true,
    usedUrl: '',
    isMultiDealerGarage: false,
};

GarageProvider.propTypes = {
    websiteId: PropTypes.number.isRequired,
    organizationId: PropTypes.number.isRequired,
    organizationUnitId: PropTypes.number.isRequired,
    organizationUnitLocation: PropTypes.string.isRequired,
    location: PropTypes.string.isRequired,
    locale: PropTypes.string.isRequired,
    contentZones: PropTypes.objectOf(
        PropTypes.arrayOf(
            PropTypes.shape({
                active: PropTypes.bool,
                group: PropTypes.string,
                id: PropTypes.number,
                location: PropTypes.string,
                position: PropTypes.number,
                type: PropTypes.string,
                value: PropTypes.string,
            })
        )
    ).isRequired,
    isNewEnabled: PropTypes.bool,
    isUsedEnabled: PropTypes.bool,
    usedUrl: PropTypes.string,
    timeSaved: PropTypes.number.isRequired,
    tradeInAmount: PropTypes.number.isRequired,
    tradeInTaxCredits: PropTypes.number.isRequired,
    deleteQuote: PropTypes.func.isRequired,
    quotes: PropTypes.arrayOf(PropTypes.instanceOf(Quote.QuoteModel)).isRequired,
    isMultiDealerGarage: PropTypes.bool.isRequired,
};

GarageProvider.displayName = 'GarageProvider';

export default GarageProvider;
